import {
  SAVE_ALL_SPACER,
  SAVE_ALL_SHISHE,
  SAVE_ALL_SHISHE_GROUP,
  SAVE_ALL_MAHSOOLE_SHISHE,
  SAVE_SELECT_GROUP_GLASS,
  SAVE_SELECT_JEDARE,
  SAVE_SELECT_SHISHE,
  SAVE_SELECT_SPACER,
  ACTION_GET_MAHSOOLE_SHISHE_RELATION,
  ACTION_GET_SHISHE_RELATION,
  ACTION_GET_SHISHE_GROUP_RELATION,
  ACTION_GET_SPACER_RELATION,
  MAHSOOLE_SHISHE_SEARCH,
  EDIT_GLASS_DETAIL, GLASS_COLOR_LIST,
} from "Stores/actionTypes";
import GlassService from "Services/http/endpoints/properties/GlassService";
import { read } from "Helpers/LocalStorage";
import StatusHandler from "Helpers/StatusHandler";
import { analyzePrice } from "Helpers/analyzePrice";
import { translatorf } from "Languages/Utility/translatorf";
import showNotify from "Helpers/Notify";

export const GetAllSpacer = (params) => {
  return async (dispatch) => {
    try {
      const response = await GlassService.GetAllSpacer(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const updatedData = data.map((data, index) => {
          return {
            ...data,
            num: index,
          };
        });
        dispatch({
          type: SAVE_ALL_SPACER,
          spacers: updatedData,
          spacersPagination: response.data.Pagination,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const insertSpacer = (data) => {
  return async (dispatch) => {
    try {
      const response = await GlassService.insertSpacer(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Successfully_added_spacer'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const editSpacer = (data) => {
  return async (dispatch) => {
    try {
      const response = await GlassService.editSpacer(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Spacer_edited_successfully'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const deleteSpacer = (data) => {
  return async (dispatch) => {
    try {
      const response = await GlassService.deleteSpacer(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('The_spacer_was_successfully_removed'),
          customClass: "success"
        });

        return true;
      } else {
        if (response.data.Message[0].Code === "RelationDelete") {
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Id: data.Id,
          };
          dispatch(getRelationSpacer(params));
        }
        return false;
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getRelationSpacer = (params) => {
  return async (dispatch) => {
    try {
      const response = await GlassService.getRelationSpacer(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({
          type: ACTION_GET_SPACER_RELATION,
          dataRelationSpacer: response.data.Value.List,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const GetAllShishe = (params) => {
  return async (dispatch) => {
    try {
      const response = await GlassService.GetAllShishe(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const updatedData = data.map((data, index) => {
          return {
            ...data,
            num: index,
          };
        });
        dispatch({
          type: SAVE_ALL_SHISHE,
          shishe: updatedData,
          shishePagination: response.data.Pagination,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const insertShishe = (data) => {
  return async (dispatch) => {
    try {
      const response = await GlassService.insertShishe(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Glass_successfully_added'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const editShishe = (data) => {
  return async (dispatch) => {
    try {
      const response = await GlassService.editShishe(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Glass_edited_successfully'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const deleteShishe = (data) => {
  return async (dispatch) => {
    try {
      const response = await GlassService.deleteShishe(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('The_glass_was_successfully_removed'),
          customClass: "success"
        });
        return true;
      } else {
        if (response.data.Message[0].Code === "RelationDelete") {
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Id: data.Id,
          };
          dispatch(getRelationShishe(params));
        }
        return false;
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getRelationShishe = (params) => {
  return async (dispatch) => {
    try {
      const response = await GlassService.getRelationShishe(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({
          type: ACTION_GET_SHISHE_RELATION,
          dataRelationShishe: response.data.Value.List,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const GetAllShisheGroup = (params) => {
  return async (dispatch) => {
    try {
      const response = await GlassService.GetAllShisheGroup(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const updatedData = data.map((data, index) => {
          return {
            ...data,
            num: index,
          };
        });
        dispatch({
          type: SAVE_ALL_SHISHE_GROUP,
          shisheGroup: updatedData,
          shisheGroupPagination: response.data.Pagination,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const insertShisheGroup = (data) => {
  return async (dispatch) => {
    try {
      const response = await GlassService.insertShisheGroup(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Glass_group_added_successfully'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const editShisheGroup = (data) => {
  return async (dispatch) => {
    try {
      const response = await GlassService.editShisheGroup(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Glass_group_edited_successfully'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const deleteShisheGroup = (data) => {
  return async (dispatch) => {
    try {
      const response = await GlassService.deleteShisheGroup(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Glass_group_was_successfully_removed'),
          customClass: "success"
        });
        return true;
      } else {
        if (response.data.Message[0].Code === "RelationDelete") {
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Id: data.Id,
          };
          dispatch(getRelationShisheGroup(params));
        }
        return false;
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getRelationShisheGroup = (params) => {
  return async (dispatch) => {
    try {
      const response = await GlassService.getRelationShisheGroup(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({
          type: ACTION_GET_SHISHE_GROUP_RELATION,
          dataRelationShisheGroup: response.data.Value.List,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const GetAllMahsooleShishe = (params) => {
  return async (dispatch) => {
    try {
      const response = await GlassService.GetAllMahsooleShishe(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = analyzePrice(response.data.Value);
        const limit = response.data.Pagination.Limit;
        const page = response.data.Pagination.Page;
        const updatedData = data.map((data, index) => {
          return {
            ...data,
            num: ((page - 1 ) * limit) + index + 1,
          };
        });
        dispatch({
          type: SAVE_ALL_MAHSOOLE_SHISHE,
          mahsooleShishe: updatedData,
          mahsooleShishePagination: response.data.Pagination,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getGlassList = (params) => async (dispatch) => {
  try {
    const response = await GlassService.getGlassList(params);
    let err = StatusHandler(response);
    if (!err.isFail) {
      const data = response.data.Value;
      const update = data.map((m) => {
        return {
          ...m,
          value: m.Id,
          label: m.Name,
        };
      });
      dispatch({
        type: SAVE_SELECT_SHISHE,
        glassList: update,
      });
    }
  } catch (err) {
      console.error('[catch error]', err)
    }
};

export const getColorList = (params) => async (dispatch) => {
  try {
    const response = await GlassService.getColorMahsooleShishe(params);
    let err = StatusHandler(response);
    if (!err.isFail) {
      const data = response.data.Value;
      const update = data.map((m) => {
        return {
          ...m,
          value: m.Id,
          label: m.Name,
        };
      });
      dispatch({
        type: GLASS_COLOR_LIST,
        colorList: update,
      });
    }
  } catch (err) {
      console.error('[catch error]', err)
    }
};

export const getJedareList = (params) => async (dispatch) => {
  try {
    const response = await GlassService.getJedareList(params);
    let err = StatusHandler(response);
    if (!err.isFail) {
      const data = response.data.Value;
      const update = data.map((m) => {
        return {
          ...m,
          value: m.Id,
          label: m.Name,
        };
      });
      dispatch({
        type: SAVE_SELECT_JEDARE,
        jedareList: update,
      });
    }
  } catch (err) {
      console.error('[catch error]', err)
    }
};

export const getSpacerList = (params) => async (dispatch) => {
  try {
    const response = await GlassService.getSpacerList(params);
    let err = StatusHandler(response);
    if (!err.isFail) {
      const data = response.data.Value;
      const update = data.map((m) => {
        return {
          ...m,
          value: m.Id,
          label: m.Name,
        };
      });
      dispatch({
        type: SAVE_SELECT_SPACER,
        spacerList: update,
      });
    }
  } catch (err) {
      console.error('[catch error]', err)
    }
};

export const getGroupProductGlass = (params) => async (dispatch) => {
  try {
    const response = await GlassService.getGroupProductGlass(params);
    let err = StatusHandler(response);
    if (!err.isFail) {
      const data = response.data.Value;
      const update = data.map((m) => {
        return {
          ...m,
          value: m.Id,
          label: m.Name,
        };
      });
      dispatch({
        type: SAVE_SELECT_GROUP_GLASS,
        groupGlassList: update,
      });
    }
  } catch (err) {
      console.error('[catch error]', err)
    }
};

export const InsertMahsooleShisheData = (data) => {
  return async (dispatch) => {
    try {
      const response = await GlassService.InsertMahsooleShisheData(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Glass_product_added_successfully'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const editMahsooleShisheData = (data) => {
  return async (dispatch) => {
    try {
      const response = await GlassService.editMahsooleShisheData(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('The_glass_product_was_edited_successfully'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const EditPriceMahsooleShishe = (data) => {
  return async (dispatch) => {
    try {
      const response = await GlassService.EditPriceMahsooleShishe(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('mission_accomplished'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const deleteMahsooleShishe = (data) => {
  return async (dispatch) => {
    try {
      const response = await GlassService.deleteMahsooleShishe(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('The_glass_product_was_successfully_removed'),
          customClass: "success"
        });
        return true;
      } else {
        if (response.data.Message[0].Code === "RelationDelete") {
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Id: data.Id,
          };
          dispatch(getRelationMahsooleShishe(params));
        }
        return false;
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getRelationMahsooleShishe = (params) => {
  return async (dispatch) => {
    try {
      const response = await GlassService.getRelationMahsooleShishe(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({
          type: ACTION_GET_MAHSOOLE_SHISHE_RELATION,
          dataRelationMahsooleShishe: response.data.Value.List,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const changePriceProductGlassGroup = (data) => {
  return async (dispatch) => {
    try {
      const response = await GlassService.changePriceProductGlassGroup(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('mission_accomplished'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const disableMahSooleShishe = (data) => {
  return async (dispatch) => {
    try {
      const response = await GlassService.disableMahSooleShishe(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('mission_accomplished'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const disableShisheGroup = (data) => {
  return async (dispatch) => {
    try {
      const response = await GlassService.disableShisheGroup(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('mission_accomplished'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const disableShishe = (data) => {
  return async (dispatch) => {
    try {
      const response = await GlassService.disableShishe(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('mission_accomplished'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const disableSpacer = (data) => {
  return async (dispatch) => {
    try {
      const response = await GlassService.disableSpacer(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('mission_accomplished'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getEditMahsooleShisheData = (params) => {
  return async (dispatch) => {
    try {
      const response = await GlassService.GetEditMahsooleShisheData(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({
          type: EDIT_GLASS_DETAIL,
          editGlassDetail: response.data.Value,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const changeMahsooleShisheSearch =
    (mahsooleShisheDataSearch) => (dispatch) => {
      dispatch({
        type: MAHSOOLE_SHISHE_SEARCH,
        mahsooleShisheDataSearch: mahsooleShisheDataSearch,
      });
    };
